module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"nationalIdentityNumber":"Fødselsnummer","willSendNotification":"Vi vil sende en SMS til mobilnummeret tilknyttet fødselsnummeret","11digitNumber":"11-sifret tall","why":"Hvorfor?"},"en":{"nationalIdentityNumber":"National ID Number","willSendNotification":"We will send an SMS to the phone number linked to the national ID number","11digitNumber":"11-digit number","why":"Why?"}}')
  delete Component.options._Ctor
}
